import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IFloorMapSpace } from '../types'
import { FloorMapSpaceFragment, SpaceAssignmentFragment } from '../fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createAllocationMoveOrders: {
    moveOrders: Array<{
      id: string
      space: IFloorMapSpace
    }>
  }
}

const mutateHandler = handleFetchResult<IPayload, Array<IFloorMapSpace>>({
  handler: (data) => data.createAllocationMoveOrders.moveOrders.map((mo) => mo.space),
  name: 'Assignment Plan',
})

export default function allocate(input: {
  assignmentPlanId: string | null
  toDepartmentId?: string | null
  moveType?: 'assignment'
  spaceIds: string[]
}): Promise<IFloorMapSpace[]> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation allocate($input: CreateAllocationMoveOrdersInput!, $assignmentPlanId: ID) {
    createAllocationMoveOrders(input: $input) {
      moveOrders {
        id
        space {
          ...FloorMapSpaceFragment
          spaceAssignment(assignmentPlanId: $assignmentPlanId) {
            ...SpaceAssignmentFragment
          }
        }
      }
    }
  }
  ${FloorMapSpaceFragment}
  ${SpaceAssignmentFragment}
`
